import { Box, styled, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { formatAsRelativeTime } from '@/src/utils/dateHelper';

const StyledBox = styled(Box)({
    color: '#616161',
});

export const CardPrefix = ({
    timestamp,
    nickname,
}: {
    timestamp: string;
    nickname?: string | null;
}) => {
    const { t } = useTranslation('common');
    const formattedTime = useMemo(() => formatAsRelativeTime(timestamp, t), [timestamp, t]);
    if (!formattedTime) {
        // need to return empty element for flex layout
        return <div />;
    }

    return (
        <StyledBox>
            <Typography variant="body2">
                {nickname ? `${nickname} ` : ''}
                {formattedTime}
            </Typography>
        </StyledBox>
    );
};
